import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterMonthsByCampaign' })
export class FilterMonthsByCampaignPipe implements PipeTransform {
  transform(items: any[], campaignTypeId: number): any[] {
    if (!items)
      return [];
    console.log(campaignTypeId);

    if (!campaignTypeId)
      return items;

    return items.filter(it => {
      return it.campaignTypeId === campaignTypeId;
    });
  }
}
